import _get from "lodash/get";
import _uniq from "lodash/uniq";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import { setCookie, getJSONFromCookie } from '../../helpers/cookie-helpers';
import { logAddition } from '../../helpers/log-interaction';
import getCardDataFromOfferApi from './get-card-data-from-offer-api';
import { CompareCardIdListCookieName, CompareCardDataCookieName } from './cookie-names';
export var ADD_CARDS_TO_COMPARE = 'ADD_CARDS_TO_COMPARE';

var addCardsToCompare = function addCardsToCompare(cards) {
  return {
    type: ADD_CARDS_TO_COMPARE,
    cards: cards
  };
};
/**
 * Use when setting entire card objects to compare. These are expected to be fully realised card
 * objects (the legacy card object, not an offer object).
 *
 * This action will
 * - add new card ids and date to the cookie (after deduping).
 * - dispatch other actions to add these to the store.
 *
 * @param {Object} args -
 * @param {Object[]|Object} args.cards - A list of, or a single legacy (finproservice) card object.
 */


export var saveCardsToCompare = function saveCardsToCompare() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState) {
    var state = args !== null && args !== void 0 && args.withContext ? {
      compareCards: getState()
    } : getState();
    var cards = Array.isArray(args.cards) ? args.cards : [args.cards]; // it seems this can also be a single card.

    var cardsDataToSetInCookie = getJSONFromCookie(CompareCardDataCookieName, {});
    var cardIDsToSetInCookie = getJSONFromCookie(CompareCardIdListCookieName, []);
    var filteredCardObjects = []; // cardsDataToSetInCookie contains only id and slug of each card, while this list contains the entire list.

    cards.forEach(function (card) {
      var id = card.id;
      cardIDsToSetInCookie.push(id);
      cardsDataToSetInCookie[id] = {
        id: id,
        slug: card.slug
      };
      filteredCardObjects.push(card);
    });
    setCookie(CompareCardIdListCookieName, JSON.stringify(_uniq(cardIDsToSetInCookie).sort()));
    setCookie(CompareCardDataCookieName, JSON.stringify(cardsDataToSetInCookie));

    if (filteredCardObjects.length) {
      dispatch(addCardsToCompare(filteredCardObjects));
      logAddition(filteredCardObjects, args.productLocation, _get(state, {}));
    }
  };
};
export var saveToCompare = function saveToCompare(args) {
  return function (dispatch) {
    var ids = args.ids,
        offerSDK = args.offerSDK,
        _args$productLocation = args.productLocation,
        productLocation = _args$productLocation === void 0 ? null : _args$productLocation;

    if (args.cards) {
      return Promise.resolve(dispatch(saveCardsToCompare(args)));
    }

    if (!offerSDK) {
      // This is going to fail anyway, might as well fail with a useful error.
      throw new Error('saveToCompare needs offerSDK when supplied only with ids but no offerSDK was supplied.');
    }

    return dispatch(getCardDataFromOfferApi(offerSDK, ids)).then(function (cards) {
      return dispatch(saveCardsToCompare({
        cards: cards,
        productLocation: productLocation
      }));
    });
  };
};